/* =============================================
   DRAPEDNUTS — Theme JS
   Light Luxury · Mobile First
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE MENU ── */
  var menuBtn = document.querySelector('.mobile-menu-btn');
  var nav     = document.querySelector('.site-nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('mobile-open');
      menuBtn.setAttribute('aria-expanded', open);
    });
  }

  /* ── MOBILE NAV STYLES (injected) ── */
  var mobileStyle = document.createElement('style');
  mobileStyle.textContent =
    '@media (max-width: 768px) {' +
    '  .site-nav.mobile-open {' +
    '    display: flex !important;' +
    '    flex-direction: column;' +
    '    position: absolute;' +
    '    top: 100%;' +
    '    left: 0; right: 0;' +
    '    background: var(--ivory);' +
    '    border-bottom: 1px solid var(--border-soft);' +
    '    padding: 16px 24px;' +
    '    gap: 4px;' +
    '    box-shadow: var(--shadow-sm);' +
    '    z-index: 999;' +
    '  }' +
    '}';
  document.head.appendChild(mobileStyle);

  /* ── SCROLL REVEAL ── */
  var reveals = document.querySelectorAll('.product-card, .category-card, .why-card, .testimonial-card, .brand-logo-item');
  reveals.forEach(function(el) { el.classList.add('reveal'); });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  reveals.forEach(function(el) { observer.observe(el); });

  /* ── AJAX ADD TO CART ── */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) {
      btn.textContent = '✓ Added';
      btn.style.background = 'var(--gold-pale)';
      btn.style.borderColor = 'var(--gold)';
    }
    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: data
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      updateCartCount();
      setTimeout(function() {
        if (btn) {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.borderColor = '';
        }
      }, 2000);
    })
    .catch(function() {
      if (btn) btn.textContent = originalText;
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
      });
  }

  /* ── SEARCH TOGGLE ── */
  var searchBtn = document.querySelector('.header-icon-btn[aria-label="Search"]');
  if (searchBtn) {
    searchBtn.addEventListener('click', function() {
      var q = document.querySelector('.header-search');
      if (!q) {
        q = document.createElement('div');
        q.className = 'header-search';
        q.innerHTML =
          '<form action="/search" method="get" style="display:flex;gap:0;">' +
          '<input name="q" type="search" placeholder="Search luxe gifting…" autofocus' +
          ' style="flex:1;padding:12px 18px;border:1px solid var(--border);border-radius:var(--radius-sm) 0 0 var(--radius-sm);font-family:var(--font-ui);font-size:0.9rem;outline:none;background:var(--white);">' +
          '<button type="submit" style="background:var(--gold);border:none;padding:12px 18px;border-radius:0 var(--radius-sm) var(--radius-sm) 0;cursor:pointer;">' +
          '<i class="fas fa-search" style="color:var(--text-dark);"></i></button></form>';
        Object.assign(q.style, {
          position: 'fixed', top: '0', left: '0', right: '0', zIndex: '1100',
          background: 'var(--ivory)', padding: '16px 24px',
          borderBottom: '1px solid var(--border-soft)',
          boxShadow: 'var(--shadow-md)'
        });
        document.body.appendChild(q);
        q.querySelector('input').focus();
        document.addEventListener('keydown', function esc(e) {
          if (e.key === 'Escape') { q.remove(); document.removeEventListener('keydown', esc); }
        });
      } else {
        q.remove();
      }
    });
  }

  /* ── SMOOTH HOVER ON HERO VISUAL ── */
  var heroImg = document.querySelector('.hero-img-frame');
  if (heroImg) {
    document.addEventListener('mousemove', function(e) {
      var rect = document.querySelector('.hero-section').getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      heroImg.style.transform = 'perspective(800px) rotateY(' + (x * 4) + 'deg) rotateX(' + (-y * 4) + 'deg)';
    });
  }

  /* ── WISHLIST TOGGLE ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-wishlist');
    if (!btn) return;
    var icon = btn.querySelector('i');
    if (icon) {
      icon.classList.toggle('far');
      icon.classList.toggle('fas');
      icon.style.color = icon.classList.contains('fas') ? 'var(--blush-deep)' : '';
    }
  });

});
